<template>
    <div v-if="restrictionProdModal.isVisible">
        <div class="overlay" @click="changeRestrictionProdModalVisibility"></div>
        <div class="modal-container">
            <div class="modal-body">Escolha os produtos da restrição</div>

            <div class="search">
                <input type="text" placeholder="Buscar" v-model="searchText" @input="filterItems" />
                <i class="fa fa-search icon"></i>
            </div>

            <div class="multi-select-list">
                <label
                    v-for="(option, key) in options"
                    :key="key"
                    class="option-label"
                >
                    <input
                        type="checkbox"
                        :value="{ CDPRODUTO: option.CDPRODUTO, NMPRODUTO: option.NMPRODUTO }"
                        v-model="selectedProducts"
                    />
                    {{ option.NMPRODUTO }}
                </label>
            </div>

            <div class="modal-footer">
                <button @click="closeModal">Confirmar</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
    name: 'WeekDaysModal',
    data () {
        return {
            selectedProducts: [],
            options: [],
            searchText: ''
        }
    },
    props: ['products'],
    emits: ['closeModal'],
    computed: {
        ...mapGetters(['restrictionProdModal'])
    },
    methods: {
        toggleList () {
        },
        closeModal () {
            this.$emit('closeModal', this.selectedProducts)
            this.selectedProducts = []
            this.changeRestrictionProdModalVisibility()
        },
        filterItems () {
            this.options = this.products.filter((item) => {
                return item.NMPRODUTO.toLowerCase().includes(this.searchText.toLowerCase())
            })
        },
        ...mapActions(['changeRestrictionProdModalVisibility'])
    },
    watch: {
        initialDays (val) {
            this.selectedOptions = val
        },
        products (val) {
            this.options = val
        }
    },
    mounted () {
        this.options = this.products
    }
}
</script>

<style lang="less" scoped>
  .modal-container {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    margin: auto auto;
    border-radius: 10px;
    z-index: 3;
    box-shadow: 2px 2px 4px var(--cardBorder);
    background-color: var(--backgroundColor);
    height: calc(100vh - 370px);
    width: 90vw;
    .modal-body {
        display: flex;
        align-items: center;
        text-align: center;
        justify-content: center;
        margin-top: 20px;
        margin-bottom: 10px;
        padding: 0 10px;
    }

    .search {
        display: flex;
        align-items: center;
        margin: 15px auto;
        width: 90%;
        // grey background
        background-color: var(--cardBackground);
        border-radius: 5px;
        box-sizing: border-box;
        padding: 10px 10px;
        position: relative;

        input {
            border: none;
            outline: none;
            background-color: transparent;
            font-size: 18px;
            font-family: Gellix;
            width: 100%;
            padding-right: 25px;
        }

        i {
            position: absolute;
            right: 10px;
            color: gray;
        }
    }

    .multi-select-list {
        height: calc(100% - 185px);
        overflow-y: auto;
        margin-bottom: 25px;
        padding-left: 20px;
    }
    .option-label {
        display: block; /* Cada opção em uma linha */
        margin: 5px 0; /* Espaçamento entre as opções */

        input {
          accent-color: var(--buttonBackground);
        }
    }

    .modal-footer {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        margin-bottom: 10px;
        margin-top: 20px;
        button {
            color: var(--buttonText);
            background: var(--buttonBackground);
            padding: 5px 10px;
            border: none;
            border-radius: 5px;
            font-size: 1rem;
            min-width: 90px;
        }
    }
}

@media (min-width: 769px) {
  .modal-container {
    width: 50%;
    margin: auto;
  }
}

.overlay {
    position: fixed;
    top: 0; left: 0;
    height: 100vh;
    width: 100vw;
    overflow: hidden;
    background: var(--backgroundColorOverlay);
    z-index: 2;
}
</style>
